import React, { useState, useEffect } from "react";

import styles from "./Video.module.scss";
import VideoPlayer from "./VideoPlayer";
import Image, { ImageProps } from "../../base/Image/Image";
import IconMS from "../../utils/IconMS/IconMS";
import VideoThumbnail from "./VideoThumbnail";
import Modal from "components/utils/Modal/Modal";

export interface VideoProps {
  url: string;
  playLabel: string;
  image?: ImageProps;
  description?: string;
  mediaFlowEmbedCode?: string;
}

const Video: React.FC<VideoProps> = ({
  url,
  image,
  playLabel,
  description,
  mediaFlowEmbedCode
}) => {
  const [showPlayer, setShowPlayer] = useState(false);
  const [isVideoReady, setIsVideoReady] = useState(false);

  const handlePlayButtonClick = () => {
    setShowPlayer(true);
  };

  const handleModalClose = () => {
    setShowPlayer(false);
    setIsVideoReady(false);
  };

  useEffect(() => {
  if (showPlayer && mediaFlowEmbedCode) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = mediaFlowEmbedCode;

    tempDiv.querySelectorAll("script").forEach((script) => {
      const newScript = document.createElement("script");
      if (script.src) {
        newScript.src = script.src;
      } else {
        newScript.textContent = script.textContent;
      }
      document.body.appendChild(newScript);
    });

    setIsVideoReady(true);
  }
}, [showPlayer, mediaFlowEmbedCode]);

  return (
    <div className={styles.video}>
      {showPlayer && (
        <Modal
          isOpen={showPlayer}
          isVisible={isVideoReady}
          onClose={handleModalClose}
          additionalTabableSelectors={["span"]}
        >
          <div className={styles.playerInModal}>

            {mediaFlowEmbedCode && mediaFlowEmbedCode.trim() !== "" ? (
              <div
                dangerouslySetInnerHTML={{ __html: mediaFlowEmbedCode }}
              />
            ) : (
              <VideoPlayer
                url={url}
                onLoad={() => setIsVideoReady(true)}
                autoPlay
              />
            )}
          </div>
        </Modal>
      )}
      <button
        className={styles.overlayButton}
        onClick={handlePlayButtonClick}
        aria-label={playLabel}
      >
        {image ? (
          <Image
            className={styles.image}
            {...image}
            sizes={{
              sm: 350,
              md: 430,
              lg: 450,
              xl: 650,
            }}
          />
        ) : (
          url && url.trim() !== "" && (
            <div className={styles.playerOutsideModal}>
              <VideoThumbnail url={url} />
            </div>
          )
        )}
        <div className={styles.playIcon}>
          <IconMS name="play_arrow" fill size="48px" />
        </div>
      </button>

      {description && <p className={styles.description}>{description}</p>}
    </div>
  );
};

export default Video;
